import React from 'react';
import TagSelector from '../../../shared/TagSelector';
import RichTextEditor from '../../../shared/RichTextEditor';

export default function MemoTagsSection({ form, setForm, tags, setTags, readOnly = false, messageTemplates = [] }) {
  const handleInsertTemplate = (e) => {
    const tpl = messageTemplates.find((t) => t.id === e.target.value);
    if (tpl) setForm((f) => ({ ...f, notes: tpl.body }));
    e.target.value = '';
  };

  return (
    <div className="proposal-memo-tags">
      <div className="memo-field">
        <div className="memo-field-label-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <label>Notes / Payment Terms</label>
          {!readOnly && messageTemplates.length > 0 && (
            <select
              className="memo-template-select"
              defaultValue=""
              onChange={handleInsertTemplate}
            >
              <option value="" disabled>Insert saved message…</option>
              {messageTemplates.map((tpl) => (
                <option key={tpl.id} value={tpl.id}>{tpl.name}</option>
              ))}
            </select>
          )}
        </div>
        <RichTextEditor
          value={form.notes}
          readOnly={readOnly}
          onChange={(html) => setForm((f) => ({ ...f, notes: html }))}
          placeholder="Add payment terms, conditions, or notes — e.g. &quot;Payment due within 30 days. A 1.5% monthly late fee applies to outstanding balances.&quot;"
        />
      </div>

      <div className="tags-field">
        <label>Tags</label>
        <TagSelector selected={tags} onChange={setTags} readOnly={readOnly} />
      </div>
    </div>
  );
}
